import Logger from '../utils/Logger'

const logger = new Logger()

export const UpdateEnrichment = (key, context, enrStr = 10) => {
  try {
    context.update({
      enrichments: [
        {
          str: enrStr,
          cat: 'clp',
          key
        }
      ]
    })
  } catch (error) {
    logger.error('uniformLogger', error, 'Unable to add enrichment')
  }
}
